var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"blocklyDiv",staticClass:"blocklyDiv",class:{'blocklyDiv-desaturated': _vm.desaturateBlocklyColors}}),_c('xml',{ref:"blocklyToolbox",staticStyle:{"display":"none"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }